(function () {
  'use strict';

  if (window.MinibundleDropdownCart) return;

  // 헤더 미니카트(#dropdown-cart)는 jewelias.min.js의 doUpdateDropdownCart()가
  // cart.js 데이터를 하드코딩 JS 템플릿으로 통째로 재렌더한다. 이 템플릿은
  // _bundle_role/_bundle line property를 전혀 모르기 때문에, 이 함수가
  // 재실행될 때마다(미니번들이 아닌 다른 상품을 담거나 수량을 바꿀 때도 포함,
  // 카트에 미니번들이 이미 담겨있는 상태라면) 번들 child 라인(¥0)이 은닉 없이
  // 노출된다. jewelias 객체는 IIFE 지역변수라 외부에서 그 함수를 가로챌 수
  // 없으므로(assets/minibundle.js 참고), 대신 실제 DOM 변화를 감시해 매번
  // snippets/wrapper-top-cart.liquid의 최초 SSR과 동일한 은닉을 재적용한다.

  var DEBOUNCE_MS = 120;
  var debounceTimer = null;

  function debounceAnnotate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(annotateFromCart, DEBOUNCE_MS);
  }

  function annotateFromCart() {
    var listEl = document.querySelector('#dropdown-cart .mini-products-list');
    if (!listEl) return;

    // /cart.js 응답이 오기 전에 doUpdateDropdownCart가 또 재렌더하면(연속 클릭 등)
    // listEl.children이 그 사이 통째로 교체된다. 응답 도착 시점에 다시
    // listEl.children을 읽으면 "이전 요청 시점의 순서"를 "지금의(다른) DOM"에
    // 잘못 매칭할 위험이 있으므로, 스냅샷을 지금 떠서 그 스냅샷에만 적용한다.
    // 그 사이 실제로 재렌더가 있었다면 이 스냅샷은 이미 DOM에서 떨어져나간
    // 상태라 속성을 써도 화면에 영향이 없고(안전), 재렌더 자체가 새 mutation을
    // 발생시켜 별도의 최신 annotateFromCart 호출로 다시 정확히 처리된다.
    var lis = Array.prototype.slice.call(listEl.children);

    fetch('/cart.js', { credentials: 'include', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        applyAnnotations(lis, (cart && cart.items) || []);
      })
      .catch(function (err) {
        console.error('[MinibundleDropdownCart] cart.js fetch failed', err);
      });
  }

  function applyAnnotations(lis, items) {
    // doUpdateDropdownCart는 cart.items를 순서대로 하나씩 append만 하고
    // 스킵/재정렬이 없으므로, 렌더된 <li> 순서 == cart.items 순서다.
    // item.id(=variant id)는 여러 라인에서 중복될 수 있어 매칭 키로 쓰지 않는다.
    var count = Math.min(lis.length, items.length);

    for (var i = 0; i < count; i++) {
      var li = lis[i];
      var props = items[i].properties || {};
      var role = props._bundle_role;

      if (!role) {
        li.removeAttribute('data-minibundle-role');
        li.removeAttribute('data-minibundle-id');
        li.classList.remove('Minibundle__ChildLine');
        continue;
      }

      li.setAttribute('data-minibundle-role', role);
      if (props._bundle) li.setAttribute('data-minibundle-id', props._bundle);

      if (role === 'child') {
        li.classList.add('Minibundle__ChildLine');
      } else {
        li.classList.remove('Minibundle__ChildLine');
      }
    }
  }

  function observe() {
    var listEl = document.querySelector('#dropdown-cart .mini-products-list');
    if (!listEl || listEl.getAttribute('data-minibundle-observed') === 'true') return;
    listEl.setAttribute('data-minibundle-observed', 'true');

    var observer = new MutationObserver(debounceAnnotate);
    observer.observe(listEl, { childList: true });
  }

  function init() {
    observe();
  }

  // jewelias.min.js(defer)가 이 스크립트보다 DOM상 뒤에 있어도(footer_scripts.liquid)
  // observe() 자체는 jewelias 로드 여부와 무관하다 — #dropdown-cart는 SSR로 이미
  // 존재하므로 DOMContentLoaded 이후 즉시 관찰을 시작해도 안전하다.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MinibundleDropdownCart = { observe: observe };
})();
